import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=23aea84d&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23aea84d')) {
      api.createRecord('23aea84d', component.options)
    } else {
      api.reload('23aea84d', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=23aea84d&", function () {
      api.rerender('23aea84d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eNDdL0hWFzYT/JS/comp/ImgFallback.vue"
export default component.exports